"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsuranceClaimDetail_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var InsuranceClaim_1 = require("./InsuranceClaim");
var InsuranceClaimDetail_Factory = /** @class */ (function () {
    function InsuranceClaimDetail_Factory() {
    }
    InsuranceClaimDetail_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            InsuranceClaim: InsuranceClaim_1.InsuranceClaim_Factory.CreateIncoming(model.InsuranceClaim),
            IsTerminalState: model.IsTerminalState,
            RecordId: model.RecordId,
            ServiceDate: Date_Factory_1.Date_Factory.CreateIncoming(model.ServiceDate, { ignoreTimePortion: true }),
        };
        return result;
    };
    InsuranceClaimDetail_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            InsuranceClaim: InsuranceClaim_1.InsuranceClaim_Factory.CreateOutgoing(model.InsuranceClaim),
            IsTerminalState: model.IsTerminalState,
            RecordId: model.RecordId,
            ServiceDate: Date_Factory_1.Date_Factory.CreateOutgoing(model.ServiceDate, { ignoreTimePortion: true }),
        };
        return result;
    };
    return InsuranceClaimDetail_Factory;
}());
exports.InsuranceClaimDetail_Factory = InsuranceClaimDetail_Factory;
